import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "01e01c23-2256-4423-bd21-df7ca9af0edb", content: "vocal chords", options: {} },
  { id: "32e96499-f20f-416e-9c9d-7bcda1562a52", content: "tongue", options: {} },
  { id: "6e0ee8ce-7bff-4b9e-ab20-c652ce029e43", content: "buccal cavity", options: {} },
  { id: "9b8ea96b-753f-47c4-a47b-f72d07b88d0d", content: "soft palate", options: {} },
  { id: "7aa5659b-5ad2-4314-be03-aa5b2b5dc56d", content: "teeth", options: {} },
  { id: "711dd9b3-ce47-41be-994c-9e0dcbf65eaa", content: "lips", options: {} },
];

const groups = [
  { id: "0057733f-7aa5-4d9e-a230-b87589c97194", content: "voiceless sounds", options: {} },
  { id: "22fda592-1c8b-4cf3-9b3f-ddd68153dd69", content: "voiced sounds", options: {} },
  { id: "a78a1415-3543-4279-80f8-b46329270e7e", content: "vocal tract", options: {} },
];

export const task: Task = {
  id: "60442007-6b1c-443b-8c88-2174f5bb9085",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    orientation: "horizontal",
    shuffle: true,
    multipleConnection: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "0057733f-7aa5-4d9e-a230-b87589c97194",
      itemsId: [
        "32e96499-f20f-416e-9c9d-7bcda1562a52",
        "6e0ee8ce-7bff-4b9e-ab20-c652ce029e43",
        "9b8ea96b-753f-47c4-a47b-f72d07b88d0d",
        "7aa5659b-5ad2-4314-be03-aa5b2b5dc56d",
        "711dd9b3-ce47-41be-994c-9e0dcbf65eaa",
      ],
    },
    {
      groupId: "22fda592-1c8b-4cf3-9b3f-ddd68153dd69",
      itemsId: ["01e01c23-2256-4423-bd21-df7ca9af0edb", "6e0ee8ce-7bff-4b9e-ab20-c652ce029e43"],
    },
    {
      groupId: "a78a1415-3543-4279-80f8-b46329270e7e",
      itemsId: [
        "01e01c23-2256-4423-bd21-df7ca9af0edb",
        "32e96499-f20f-416e-9c9d-7bcda1562a52",
        "6e0ee8ce-7bff-4b9e-ab20-c652ce029e43",
        "9b8ea96b-753f-47c4-a47b-f72d07b88d0d",
        "7aa5659b-5ad2-4314-be03-aa5b2b5dc56d",
        "711dd9b3-ce47-41be-994c-9e0dcbf65eaa",
      ],
    },
  ],
};
